module.exports = __webpack_public_path__ + "img/手势识别--大图--比ok前gif.82f400de.gif";